const onboardingTemplate = {
  customise_onboarding: "Customise Onboarding",
  onboarding_templates: "Onboarding Templates",
  onboarding_template_groups: "Document Groups",
  documents_lower: "documents",
  document_groups_lower: "document groups",
  mandatory: "mandatory",
  add_expiry: "Add Expiry",
  add_template: "Add Template",
  add_group: "Add Group",
  documents: "Documents",
  document_groups: "Document Groups",
  document_name: "Document Name",
  is_mandatory: "Mandatory",
  add_document: "Add Document",
  add_document_group_title: "Add Document Group",
  edit_document_group_title: "Edit Document Group",
  document_group_dialog_subtitle:
    "Group the documents you want to request together, and set which ones are mandatory or expire.",
  add_onboarding_template_title: "Add Onboarding Template",
  edit_onboarding_template_title: "Edit Onboarding Template",
  onboarding_template_dialog_subtitle:
    "Choose the document groups a supplier on this template will be asked to provide.",
  select_document_groups: "Select document groups",
  select_document_groups_dialog_subtitle:
    "Pick the document groups to include in this template.",
  select: "Select",
  all_document_groups_selected:
    "All available document groups are already selected.",
  no_groups_selected_yet: "No document groups selected yet.",
  group_name: "Group name",
  template_name: "Template name",
  description_optional: "Description (optional)",
  enter_description: "Enter Description",
  search_to_add_document_groups: "Search to add document groups",
  mandatory_documents_count: "{{count}} mandatory documents",
  no_document_groups_yet:
    "No document groups yet. Create one from the Document Groups tab first.",
  save_group: "Save Group",
  save_template: "Save Template",
  no_templates_found: "No onboarding templates found",
  no_groups_found: "No document groups found",
  template_created_successfully: "Onboarding template created successfully",
  template_updated_successfully: "Onboarding template updated successfully",
  template_deleted_successfully: "Onboarding template deleted successfully",
  group_created_successfully: "Document group created successfully",
  group_updated_successfully: "Document group updated successfully",
  group_deleted_successfully: "Document group deleted successfully",
  delete_template_title: "Are you sure you want to delete onboarding template?",
  delete_template_description:
    "Once an onboarding template is deleted it will also be removed from all suppliers which use it",
  delete_group_title: "Are you sure you want to delete document group?",
  delete_group_description:
    "Once an onboarding template is deleted it will also be removed from all onboarding templates which mention it",
  remove_group_from_template_title:
    "Are you sure you want to remove document group?",
  remove_group_from_template_description:
    "This document group will be removed from this onboarding template. The group itself will not be deleted.",
  name_required: "Name is required",
  at_least_one_document_required: "At least one document is required",
  at_least_one_group_required: "At least one group is required",
  something_went_wrong: "Something went wrong",
};

export default onboardingTemplate;
